import { Api } from 'utils';

class StorageService {
  static getSignedUrl = async (key: string): Promise<string | null> => {
    try {
      const res: any = await Api.createResponse('app/storage/signed-url', {
        key,
      });
      return res?.url || null;
    } catch {
      return null;
    }
  };

  /**
   * Abre un archivo de S3 en una nueva pestaña usando pre-signed URLs.
   * Abre la pestaña inmediatamente (click síncrono) para evitar que el
   * navegador la bloquee como popup, luego obtiene la URL firmada y redirige.
   * Si falla, cierra la pestaña vacía y retorna false.
   */
  static openFile = async (key: string): Promise<boolean> => {
    if (!key) return false;
    // Abrir pestaña vacía de forma síncrona para evitar bloqueo de popups
    const win = window.open('', '_blank');
    try {
      const url = await StorageService.getSignedUrl(key);
      if (url && win) {
        win.location.href = url;
        return true;
      }
      // Si no se obtuvo la URL o la ventana fue bloqueada, cerrar y retornar false
      win?.close();
      return false;
    } catch {
      win?.close();
      return false;
    }
  };
}

export default StorageService;
